import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {
  BranchService,
  BoardActivityDto,
} from 'src/app/services/branch.service';
import {
  ToasterService,
  ToastStatus,
} from 'src/app/core/toaster/toaster.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import {
  CustomDateAdapter,
  MONTH_YEAR_FORMATS,
} from '../../utils/custom-date-adapter';

@Component({
  selector: 'app-board-activity',
  templateUrl: './board-activity.component.html',
  styleUrls: ['./board-activity.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMATS },
  ],
})
export class BoardActivityComponent implements OnInit {
  displayedColumns: string[] = [
    'date',
    'boardType',
    'address',
    'activityType',
    'status',
    'notes',
    'adminNotes',
  ];
  dataSource: MatTableDataSource<BoardActivityDto> = new MatTableDataSource();
  isLoading = false;

  // Date Control
  date = new FormControl(new Date());
  minDate = new Date(2023, 0, 1);

  // Filters
  activityTypeFilter = new FormControl([]);
  // Define options with both display name and value
  activityTypeOptions = [
    { value: 'erect', viewValue: 'Erect' },
    { value: 'reerect', viewValue: 'Reerect' },
    { value: 'change', viewValue: 'Change' },
    { value: 'collect', viewValue: 'Collect' },
    { value: 'stray', viewValue: 'Stray' },
  ];

  // We need to keep the original data to filter locally
  originalData: BoardActivityDto[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private branchService: BranchService,
    private toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.fetchActivities();

    // Subscribe to filter changes
    this.activityTypeFilter.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  fetchActivities(): void {
    const ctrlValue = this.date.value;
    if (!ctrlValue) return;

    const month = ctrlValue.getMonth() + 1; // 0-indexed
    const year = ctrlValue.getFullYear();

    this.isLoading = true;
    this.branchService.fetchBoardActivity(month, year).subscribe({
      next: data => {
        this.originalData = data;
        this.dataSource.data = data;
        this.applyFilter(); // Apply any existing filters
        this.isLoading = false;
      },
      error: err => {
        console.error(err);
        this.toasterService.toast(
          ToastStatus.error,
          'Failed to load activities'
        );
        this.isLoading = false;
        this.dataSource.data = [];
        this.originalData = [];
      },
    });
  }

  applyFilter() {
    const selectedTypes: string[] | null = this.activityTypeFilter.value;
    if (!selectedTypes || selectedTypes.length === 0) {
      this.dataSource.data = this.originalData;
      return;
    }

    this.dataSource.data = this.originalData.filter(item =>
      selectedTypes.includes(item.activityType)
    );
  }

  chosenYearHandler(normalizedYear: Date) {
    const ctrlValue = this.date.value!;
    const newDate = new Date(ctrlValue);
    newDate.setDate(1);
    newDate.setFullYear(normalizedYear.getFullYear());
    this.date.setValue(newDate);
  }

  chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    const ctrlValue = this.date.value!;
    const newDate = new Date(ctrlValue);
    newDate.setDate(1);
    newDate.setMonth(normalizedMonth.getMonth());
    this.date.setValue(newDate);
    datepicker.close();
    this.fetchActivities();
  }
}
